import KidGif from '@assets/kid-dance.gif'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SetupStep } from './SetupStep'

export const WalletSetupSuccess = () => {
  const { t } = useTranslation()

  return (
    <SetupStep title={t('walletSuccess.title')} description={t('walletSuccess.description')}>
      <img src={KidGif} alt="" className="w-full rounded-md" />
    </SetupStep>
  )
}
